<template>
  <div id="download-progres" class="mc-download">
    <div class="mc-download__header d-flex justify-content-between">
      <div class="d-flex">
        <h4>
          {{
            downloadVideoHistoriesInProgreess.length
              ? $t('videoHistory.widgetDownload.preparingDownload')
              : $t('videoHistory.widgetDownload.downloadFinish')
          }}
        </h4>
        <span
          v-if="downloadVideoHistoriesInProgreess.length"
          class="mx-2 spinner-border spinner-border-sm text-white"
        ></span>
      </div>
      <div>
        <i
          :style="{
            position: downloadVideoHistoriesInProgreess.length ? 'static' : undefined,
          }"
          class="mc-fa icon-fill_arrow-ios-up"
          @click="toggleDownload()"
        ></i>
        <i class="mc-fa icon-outline_close ms-2" @click="closeDownload()"></i>
      </div>
    </div>
    <div class="accordion mc-download__body" role="tablist">
      <div class="mc-download__body-wrapper">
        <div class="mc-download__info" header-tag="header" role="tab">
          <div v-b-toggle.download-1 class="d-flex justify-content-between">
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.complete') }} ({{
                downloadVideoHistoriesSuccess.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-1"
          class="mc-download__list"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <template v-if="downloadVideoHistoriesSuccess.length">
            <VideoSuccess
              v-for="video in downloadVideoHistoriesSuccess"
              :key="video.downloadId"
              :licensePlate="video.licensePlate"
              :convertedChannel="video.convertedChannel"
              :deviceTimezone="video.deviceTimezone"
              :startTime="video.startTime"
              :endTime="video.endTime"
              :downloadOn="video.downloadOn"
              :url="video.url"
              :mediaFilename="video.mediaFilename"
              :isVideoDemo="isVideoDemo"
              :downloadId="video.downloadId"
              :vehicleId="video.vehicleId"
            />
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadSuccess') }}
            </p>
          </template>
        </b-collapse>
      </div>
      <div class="mc-download__body-wrapper">
        <div class="mc-download__info" header-tag="header" role="tab">
          <div v-b-toggle.download-2 class="d-flex justify-content-between">
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.running') }} ({{
                downloadVideoHistoriesInProgreess.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-2"
          ref="downloadInProgress"
          class="mc-download__list"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <template v-if="downloadVideoHistoriesInProgreess.length">
            <VideoInProgress
              v-for="video in downloadVideoHistoriesInProgreess"
              :key="video.downloadId"
              :licensePlate="video.licensePlate"
              :convertedChannel="video.convertedChannel"
              :deviceTimezone="video.deviceTimezone"
              :startTime="video.startTime"
              :endTime="video.endTime"
              :downloadOn="video.downloadOn"
              :progress="Number(video?.progress?.slice(0, -1) ?? 2)"
            />
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadProcess') }}
            </p>
          </template>
        </b-collapse>
      </div>
      <div class="mc-download__body-wrapper">
        <div header-tag="header" role="tab" class="mc-download__info">
          <div v-b-toggle.download-3 class="d-flex justify-content-between">
            <!--  eslint-disable-next-line vue/singleline-html-element-content-newline -->
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.stop') }} ({{
                downlaodVideoHistoriesFailed.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-3"
          class="mc-download__list mc-download__list--fail"
          role="tabpanel"
          visible
          accordion="my-accordion"
        >
          <template v-if="downlaodVideoHistoriesFailed.length">
            <VideoFailed
              v-for="video in downlaodVideoHistoriesFailed"
              :key="video.downloadId"
              :licensePlate="video.licensePlate"
              :convertedChannel="video.convertedChannel"
              :deviceTimezone="video.deviceTimezone"
              :startTime="video.startTime"
              :endTime="video.endTime"
              :downloadOn="video.downloadOn"
            />
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadStop') }}
            </p>
          </template>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { GET_PAYLOAD } from '@/services/api/auth'
import VideoInProgress from '@/components/WidgetDownload/video/InProgress.vue'
import VideoSuccess from '@/components/WidgetDownload/video/Success.vue'
import VideoFailed from '@/components/WidgetDownload/video/Failed.vue'
moment.locale('id')

export default {
  components: {
    VideoInProgress,
    VideoSuccess,
    VideoFailed,
  },
  mixins: [Helper, MixPanel],
  data() {
    return {
      payloadWs: null,
      isWsConnected: false,
      forceDisconnect: false,
      socket: null,
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    ...mapState('vehicle', ['dvhPollingData']),
    loadingDownload() {
      return this.$store.state.vehicle.isLoadingDownloadVideoHistoriesWidget
    },
    downloadVideoHistoriesInProgreess() {
      // This is for data mock
      // return [
      //   {
      //     licensePlate: 'EH03T - 241',
      //     convertedChannel: 1,
      //     startTime: '2025-11-12T22:00:36.000Z',
      //     endTime: '2025-11-12T22:01:36.000Z',
      //     downloadOn: '2025-11-13T02:56:21.000Z',
      //     progress: '1%',
      //     status: 'I',
      //     deviceTimezone: 7,
      //     downloadId: 803495,
      //   },
      // ]
      if (Object.keys(this.dvhPollingData).length === 0) return []
      return Object.keys(this.dvhPollingData)
        .filter((downloadId) => this.dvhPollingData[downloadId].status === 'I')
        .map((downloadId) => this.dvhPollingData[downloadId])
    },
    downlaodVideoHistoriesFailed() {
      // This is for data mock
      // return [
      //   {
      //     licensePlate: 'EH03T - 241',
      //     convertedChannel: 1,
      //     startTime: '2025-11-12T22:00:36.000Z',
      //     endTime: '2025-11-12T22:01:36.000Z',
      //     downloadOn: '2025-11-13T02:56:21.000Z',
      //     status: 'F',
      //     deviceTimezone: 7,
      //     downloadId: 803495,
      //   },
      // ]
      if (Object.keys(this.dvhPollingData).length === 0) return []
      return Object.keys(this.dvhPollingData)
        .filter((downloadId) => this.dvhPollingData[downloadId].status === 'F')
        .map((downloadId) => this.dvhPollingData[downloadId])
    },
    downloadVideoHistoriesSuccess() {
      // This is for data mock
      // return [
      //   {
      //     licensePlate: 'EH03T - 241',
      //     convertedChannel: 1,
      //     startTime: '2025-11-12T22:00:36.000Z',
      //     endTime: '2025-11-12T22:01:36.000Z',
      //     downloadOn: '2025-11-13T02:56:21.000Z',
      //     status: 'S',
      //     deviceTimezone: 7,
      //     downloadId: 803495,
      //     mediaFilename: 'BigBuckBunny.mp4',
      //     vehicleId: 33317,
      //     url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
      //   },
      // ]
      return Object.keys(this.dvhPollingData)
        .filter((downloadId) => this.dvhPollingData[downloadId].status === 'S')
        .map((downloadId) => this.dvhPollingData[downloadId])
    },
    isVideoDemo() {
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      if (!this.$route.query?.vehicleId) {
        return null
      }
      return Object.keys(dataDemoVideoHistory).includes(this.$route.query?.vehicleId.toString())
    },
  },

  async mounted() {
    await this.loadPayloadWsDvh()
    await this.startWebSocket()
  },
  beforeDestroy() {
    this.forceDisconnect = true
    if (this.socket) {
      this.socket.close()
    }
  },
  methods: {
    async startWebSocket() {
      if (!this.payloadWs) return
      const obj = {
        type: 'update_tags',
        data: this.payloadWs,
      }
      this.socket = new WebSocket(
        `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('wsToken')}`
      )
      this.socket.onopen = () => {
        this.socket.send(JSON.stringify(obj))
        this.isWsConnected = true
      }

      this.socket.onmessage = (dataWs) => {
        const data = JSON.parse(dataWs.data)
        if (data.type?.startsWith('dvh-')) {
          const dataDvh = data.payload
          const isInProgress = this.downloadVideoHistoriesInProgreess.some(
            (dvh) => dvh.downloadId === dataDvh.downloadId
          )
          if ((dataDvh.status === 'S' || dataDvh.status === 'F') && isInProgress) {
            this.$store.commit(
              'vehicle/removeDownloadVideoPerItemStatus',
              dataDvh.vehicleId +
                '_' +
                dataDvh.channel +
                '_' +
                new Date(dataDvh.startTime).toISOString()
            )
            this.$store.commit('vehicle/updateDvhPollingData', {
              downloadId: dataDvh.downloadId,
              data: dataDvh,
            })
          }
        }
      }

      this.socket.onclose = async () => {
        if (this.forceDisconnect) return
        this.startWebSocket()
      }
    },
    async loadPayloadWsDvh() {
      try {
        const filterByType = ['DownloadVideoHistory']
        const res = await this.$apollo.query({
          query: GET_PAYLOAD,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              filterByType,
            },
          },
        })
        const payload = res.data.getPayload.payload.payload
        this.payloadWs = payload
      } catch (error) {
        console.error(error)
        this.$mcToast.error(this.$t('global.somethingWentWrong'))
      }
    },
    toggleDownload() {
      var toggleDownload = document.getElementById('download-progres')
      toggleDownload.classList.toggle('show-body')
    },

    closeDownload() {
      document.body.classList.remove('mc-widget-download')
      this.$store.commit('vehicle/setShowWidgetDownload', false)
      this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', false)
      this.$store.commit('vehicle/resetDownloadVideoPerItemStatus')
    },

    checkVideoitemActiveInRanges(video, downloadPerItemActive) {
      return downloadPerItemActive.some((item) => {
        return (
          this.isBetweenDate(item.startTime, video.startTime, video.endTime) ||
          this.isBetweenDate(item.endTime, video.startTime, video.endTime) ||
          (video.startTime === item.startTime && video.endTime === item.endTime)
        )
      })
    },
  },
}
</script>
